import React from 'react'
import styled from 'styled-components'
import { Link, graphql, useStaticQuery } from 'gatsby'
import logo from "../images/works-logo.png"
import PropTypes from 'prop-types'

const Wrapper = styled.div`
    margin: 8rem 0 1rem;
    padding: 1rem ${props => props.theme.spacer.horizontal};
    text-align: center;
    position: absolute;
    color: ${props => props.theme.colors.grey};
    @media (max-width: ${props => props.theme.breakpoints.s}) {
        margin: 5rem 0 1rem;
    }
    a {
        text-decoration: none;
        color: ${props => props.theme.brand.primary};
    }
    .about {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: start;
            -ms-flex-align: start;
                align-items: flex-start;
        -webkit-box-pack: center;
            -ms-flex-pack: center;
                justify-content: center;
        margin: 0 auto;
        padding: 0 2rem 0 0;
        max-width: 55rem;
        @media (max-width: ${props => props.theme.breakpoints.s}) {
            -webkit-box-orient: vertical;
            -webkit-box-direction: normal;
            -ms-flex-direction: column;
            flex-direction: column;
            margin:0;
            padding: 0;
        }
    }
    .about__left-column {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-flex: 0;
            -ms-flex: 0 0 60%;
                flex: 0 0 60%;
        -webkit-box-pack: end;
            -ms-flex-pack: end;
                justify-content: flex-end;
    }
    .about__right-column {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
            -ms-flex-direction: column;
                flex-direction: column;
        -webkit-box-align: start;
            -ms-flex-align: start;
                align-items: flex-start;
        -webkit-box-pack: start;
            -ms-flex-pack: start;
                justify-content: flex-start;
        padding: 0 0 0 2rem;
        -webkit-box-flex: 0;
            -ms-flex: 0 0 40%;
                flex: 0 0 40%;
        @media (max-width: ${props => props.theme.breakpoints.s}) {
            -webkit-box-flex: 0;
            -ms-flex: 0 0 100%;
            flex: 0 0 100%;
            width: 100%;
            padding: 0;
            -webkit-box-align: center;
                -ms-flex-align: center;
            align-items: center;
        }
    }
    .works-logo {
        max-width: 100%;
        @media (max-width: ${props => props.theme.breakpoints.s}) {
            max-width: 12rem;
            margin-left: .9rem;
        }
    }
    .site-desc {
        color: #454545;
        font-size: .9rem;
        line-height: 19px;
        text-align: left;
        margin: 0;
        @media (max-width: ${props => props.theme.breakpoints.s}) {
            margin: 1rem;
         }
    }
    .font-color-primary {
        color: ${props => (props.theme.brand.primary)}; 
    }
    .font-color-mdx {
        color: {props.data.mdx.frontmatter.color}; 
    }
`


const About = (props) => (
        <Wrapper data-testid="about">
            <div className="about">
                    <div className="about__left-column">
                        <Link to="/works" data-testid="home-title-link">
                            <img className="works-logo" src={logo} alt="Logo" />
                        </Link>
                    </div>
                    <div className="about__right-column">
                    <p className="site-desc">UI/UX Designer & Developer<br />
                            <span className="font-color-primary font-color-mdx" >From design to all things digital</span>
                    </p>
                    </div>
            </div>
        </Wrapper>
    )

export default About


  export const pageQuery = graphql`
    query FitColor {
      mdx {
        frontmatter {
          color
        }
      }
    }
  `
